import React, {useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";

import mistEliminators from "../../../assets/images/solutions/MistEliminators.png";
import CompanyCarousel from "../../../components/carousel";
import Footer from "../../../components/footer";
import Header from "../../../components/header";
import * as S from "./styles";
import GetInTouch from "../../../components/getInTouch";
import Questions from "../../../components/questions";
import Breadcrumbs from "../../../components/breadcrumbs";
import {GlobalContext} from "../../../context/global/globalContext";

function Brink() {
  const {setBreadcrumbs} = useContext(GlobalContext);
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      {label: "Home", path: "/"},
      {label: "Technologies", path: "/technologies"},
      {label: "Brink", path: "/technologies/brink"},
    ]);
  }, [location, setBreadcrumbs]);

  const questionsData = [
    {
      question: "How do mist eliminators differ from mesh pads?",
      answer: "They’re more efficient at removing sub-micron droplets.",
    },
    {
      question: "Do they reduce pressure drop?",
      answer: "Yes, many designs balance high efficiency with low pressure loss.",
    },
    {
      question: "Are they easy to install and maintain?",
      answer: "Very — they can be accessed and replaced easily with minimal downtime.",
    },
  ];

  return (
    <>
      <Header />
      <S.Container>
        <Breadcrumbs />

        <S.MainHeading>Brink® Mist Eliminator</S.MainHeading>

        <S.TwoColumnSection>
          <S.Column>
            <S.Paragraph>
              Mist eliminators are high efficient filters designed to remove sub-micron liquid
              particles from gas streams in a wide range of industrial and chemical processes. With
              removal efficiencies of up to 99,95%, they are ideal for both coarse droplets (&gt; 15
              µm) and sub-micron mist (&gt; 3 µm), ensuring clean gas flow and protection of
              downstream equipment.
            </S.Paragraph>
            <S.Paragraph>
              All of Ecosystems Europe mist eliminators are tailored to your specific application
              and operating conditions. Our range includes mist eliminators, Brink filter candles,
              mesh pad demisters, and vane or chevron droplet separators.
            </S.Paragraph>
          </S.Column>
          <S.ImageContainer>
            <img src={mistEliminators} alt="Mist Eliminators Equipment" />
          </S.ImageContainer>
        </S.TwoColumnSection>

        <S.Section>
          <S.SectionTitle>How Mist Eliminators work</S.SectionTitle>
          <S.Paragraph>
            Mist eliminators separate fine liquid particles—often submicron in size—from gas
            streams. As the gas passes through a dense fiber bed, droplets are captured by inertial
            impaction and Brownian motion. The liquid droplets merge into larger droplets, which
            then drain by gravity through a patented secondary layer, preventing re-entrainment.
          </S.Paragraph>
          <S.Paragraph>
            This process effectively removes acid mists, organic vapors, amines, and soluble
            particulates with efficiencies up to 99,95%.
          </S.Paragraph>
          <S.Paragraph>Mist eliminators are used across industries such as:</S.Paragraph>

          <S.List>
            <S.BulletItem color="black">
              Chemical production (e.g., chlorine, nitric and phosphoric acid)
            </S.BulletItem>
            <S.BulletItem color="black">Sulphuric acid plants</S.BulletItem>
            <S.BulletItem color="black">Fertilizer manufacturing</S.BulletItem>
            <S.BulletItem color="black">Compressed gas systems</S.BulletItem>
            <S.BulletItem color="black">Polymer and textile processing</S.BulletItem>
            <S.BulletItem color="black">Bitumen and asphalt plants</S.BulletItem>
          </S.List>

          <S.Paragraph>
            They are low-maintenance, self-cleaning, and ideal for both standard and harsh
            environments.
          </S.Paragraph>
        </S.Section>

        <S.TwoColumnSection>
          <S.Column>
            <S.SectionTitle>Process Design</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">Temperature Ranges: 5–92°C</S.BulletItem>
              <S.BulletItem color="blue">Flow Rates: 500 to 800,000 Nm³/h</S.BulletItem>
              <S.BulletItem color="blue">Operating Pressure: -100 to +200 mbar</S.BulletItem>
              <S.BulletItem color="blue">Pressure Drop: 10–60 mbar</S.BulletItem>
              <S.BulletItem color="blue">Efficiency: up to 99,9% removal efficiency</S.BulletItem>
            </S.List>
          </S.Column>
          <S.Column>
            <S.SectionTitle>Materials</S.SectionTitle>
            <S.List>
              <S.BulletItem color="blue">
                Stainless steel (316L, 304L, 904L, high-nickel alloys)
              </S.BulletItem>
              <S.BulletItem color="blue">FRP, PE, and PP</S.BulletItem>
              <S.BulletItem color="blue">Glass fiber</S.BulletItem>
            </S.List>
          </S.Column>
        </S.TwoColumnSection>

        <S.QuestionsSpacing>
          <Questions items={questionsData} />
        </S.QuestionsSpacing>

        <S.ContainerTitles>
          <S.MiniTitle>Our Partners</S.MiniTitle>
          <S.Title>
            We partner with industry leaders to create clean alternatives to traditional industrial
            processes
          </S.Title>
        </S.ContainerTitles>

        <CompanyCarousel />
        <GetInTouch />
      </S.Container>
      <Footer />
    </>
  );
}

export default Brink;
